import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/shallow'
import { ENV_API_BASE_URL } from '../environments'
import { CountryOption, FALLBACK_COUNTRY_CODES, getCountryOptions } from '../helper/country-options'
import { getCountriesUrl } from '../helper/get-countries-url'
import { CountriesResponse } from '../types'
import { useStore } from './use-store'

export const useCountries = () => {
	const { language, feedType } = useStore(useShallow(({ language, feedType }) => ({ language, feedType })))
	const [countryCodes, setCountryCodes] = useState<string[]>()

	useEffect(() => {
		let cancelled = false

		const fetchCountries = async () => {
			try {
				const request = await fetch(getCountriesUrl({ apiBaseUrl: ENV_API_BASE_URL, feedType }))

				if (!request.ok) {
					throw new Error('Failed to fetch countries')
				}

				const { success, countries }: CountriesResponse = await request.json()

				if (!success) {
					throw new Error('Countries request was not successful')
				}

				if (!cancelled) {
					setCountryCodes(countries)
				}
			} catch {
				if (!cancelled) {
					setCountryCodes(FALLBACK_COUNTRY_CODES)
				}
			}
		}

		fetchCountries()

		return () => {
			cancelled = true
		}
	}, [feedType])

	const countryOptions: CountryOption[] = getCountryOptions(countryCodes ?? [], language)

	return { countryOptions }
}
